/**
 * InspirationChatView.jsx
 * Wrapper pour intégrer InspirationModule dans l'espace Chat
 * Lorsque l'utilisateur sélectionne "Analyser Sources" dans le ToolModeDropdown
 */

import React from 'react';
import { ArrowLeft } from 'lucide-react';
import InspirationModule from '../CP-HomePage/InspirationModule';
import { auth } from '../firebase';

const InspirationChatView = ({
  competenceData,
  userObjective,
  onExitInspirationMode
}) => {
  const [userId, setUserId] = React.useState(null);

  // Récupérer le userId depuis Firebase Auth
  React.useEffect(() => {
    const currentUser = auth.currentUser;
    if (currentUser?.uid) {
      setUserId(currentUser.uid);
    } else {
      console.warn('Aucun utilisateur connecté');
    }
  }, []);

  // Si pas de userId, afficher un message
  if (!userId) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Veuillez vous connecter pour accéder au module d'inspiration</p>
          {onExitInspirationMode && (
            <button
              onClick={onExitInspirationMode}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Retour au Chat
            </button>
          )}
        </div>
      </div>
    );
  }

  // Préparer la compétence courante pour InspirationModule
  const currentCompetence = competenceData ? {
    id: competenceData.id,
    title: userObjective || competenceData.title || 'Mon objectif',
    ...competenceData
  } : null;

  if (!currentCompetence) {
    return (
      <div className="flex items-center justify-center h-full p-8">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Aucune compétence sélectionnée</p>
          {onExitInspirationMode && (
            <button
              onClick={onExitInspirationMode}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Retour au Chat
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full flex flex-col bg-gray-50">
      {/* Barre de navigation pour retourner au chat */}
      {onExitInspirationMode && (
        <div className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3 shadow-sm">
          <button
            onClick={onExitInspirationMode}
            className="flex items-center gap-2 px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            title="Retour au Chat"
          >
            <ArrowLeft size={20} />
            <span className="text-sm font-medium hidden sm:inline">Retour au Chat</span>
          </button>

          <div className="flex-1 text-center">
            <h2 className="text-lg font-semibold text-gray-800">
              Recherche et Analyse de sources Web
            </h2>
            <p className="text-xs text-gray-600 mt-0.5">
              Recherche • Sources • Synthèse
            </p>
          </div>

          <div className="w-24 hidden sm:block"></div>
        </div>
      )}

      {/* Module d'inspiration complet */}
      <div className="flex-1 overflow-auto">
        <InspirationModule
          userId={userId}
          currentCompetence={currentCompetence}
          onSelectCompetence={() => {}} // Pas de changement de compétence dans le contexte Chat
          userObjectives={userObjective}
          onNavigateToStep={() => {}} // Pas de navigation vers étapes dans ce contexte
        />
      </div>
    </div>
  );
};

export default InspirationChatView;
